/* eslint-disable react/prop-types */
import React from 'react';

export const TextDetail = ({ detail }) => (
    <div className="detail-value" dangerouslySetInnerHTML={{ __html: detail.value }} />
);
